module.exports = __webpack_public_path__ + "static/media/icon-instagram.3e3e1dd9.svg";